import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { Table, Modal, Button, Input, Dropdown, Checkbox } from 'semantic-ui-react'
import { toast } from 'react-toastify';
import { FileDropZone } from '../common/FileDropZone';

export const PollAddGPT = (props) => {
    const [allCategories, setAllCategories] = useState([])
    const [newCategory, setNewCategory] = useState(false)
    const [superCategory, setSuperCategory] = useState(null)
    const [subCategory, setSubCategory] = useState(null)
    const [description, setDescription] = useState(null)
    const [question, setQuestion] = useState(null)
    const [choiceType, setChoiceType] = useState('text')
    const [choices, setChoices] = useState([])
    const [choice1, setChoice1] = useState("")
    const [choice2, setChoice2] = useState("")
    const [choice3, setChoice3] = useState("")
    const [choice4, setChoice4] = useState("")
    const [choice5, setChoice5] = useState("")
    const [choice6, setChoice6] = useState("")
    const [dropdownOptions, setDropdownOptions] = useState([])
    const [bulkUploadPollModal, setBulkUploadPollModal] = useState(false)
    const [bulkUploadResponse, setBulkUploadResponse] = useState(null)
    const [showBulkUploadResponseModal, setShowBulkUploadResponseModal] = useState(false)
    const [responseModalText, setResponseModalText] = useState('')

    var token = localStorage.getItem('accessToken')
    const baseURL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_API_HOST_URL : 'http://localhost:8080';

    useEffect(() => {
        getCategories()
    }, []);

    async function getCategories() {
        try{
            const response = await axios.get(baseURL + '/get-poll-categories', {
                headers: {
                    Authorization: "Bearer " + token
                }
            });
            if (response && response.status === 200 && response.data){
                setAllCategories(response.data.data)
                setDropdownOptions(response.data.data.map(item => {
                    return {
                        key: item._id,
                        text: item.category.charAt(0).toUpperCase() + item.category.slice(1) + " - " + item.superCategory.charAt(0).toUpperCase() + item.superCategory.slice(1),
                        value: item._id
                    }
                }))
            }else{
                console.log("Api error")
            }
        }catch(error){
            console.log(error)
        }
    }

    const onPollBulkUploadModalClose = async (e) => {
        e.preventDefault();
    };

    const handleCsvUpload = async (file) => {
        setBulkUploadPollModal(false);

        const formData = new FormData();
        formData.append("file", file);

        const response = await axios.post(baseURL + `/bulk-upload-polls-csv`, formData, {
            headers: {
                Authorization: "Bearer " + token
            }
        }).catch(error => {
            toast.error(`API failed. Please try again.`, {autoClose: 3000});
            return null;
        });

        console.info({ pollsBulkUploaded: response });

        if (response && response.data && response.data.status) {
            const { code } = response.data.status;
            if (code && code === `pollSuggestions/saved`) {
                // toast.success(`Polls uploaded successfully.`, {autoClose: 3000});
                setBulkUploadResponse(response.data.data)
                setResponseModalText(`${response.data.data.success.length}/${response.data.data.success.length+response.data.data.fail.length} poll templates uploaded successfully.`)
                setShowBulkUploadResponseModal(true)
                getCategories();
            } else {
                toast.error(`API failed. Please try again.`, {autoClose: 3000});
            }
        }
        return null;
    }

    const savePoll = async () => {
        console.log("access token = ", token)
        const response = await axios.post(baseURL + '/pollsData/add', {
            newCategory, superCategory, subCategory, description,
            question, choiceType, choice1, choice2, choice3,
            choice4, choice5, choice6
        }, {
            headers: {
                Authorization: "Bearer " + token
            }
        }).catch(error => {
            if (error.isAxiosError && error.response.data && error.response.data.status) {
                console.info(error.response.data.status);
                var code = error.response.data.status.code;
                var message = error.response.data.status.message;
                toast.error(message, {autoClose: 3000});
                return null
            } else {
                toast.error(`API failed. Please try again.`, {autoClose: 3000});
                return null
            }
        })
        if(response.status === 200){
            toast.success(response.data.status.message, {autoClose: 3000});
            getCategories();
        }else{
            toast.error(response.data.status.message, {autoClose: 3000});
        }
    }

    return (
        <div style={{width: '100%'}}>
            <div style={{ backgroundColor: "#fafafa" }}>
                <hr />
                <h3 style={{ textAlign: "center" }}>Add Poll Data</h3>
                <hr />
            </div>
            <div>
                <div>Bulk Upload</div>
                <div className="item">
                    <button className="ui button" onClick={event => setBulkUploadPollModal(true)}>Bulk Upload</button>
                </div>
            </div>
            <div>OR</div>
            <div>
                <div>Individual Upload</div>
                <form className="ui form" style={{ marginLeft: "30px" }}>
                    {/* {!newCategory && <div className="inline fields">
                        <div className="field three wide">
                            <label>Select sub-category:</label>
                        </div>
                        <Dropdown
                            placeholder='Categories'
                            fluid
                            search
                            selection
                            className="categoryDropDown"
                            options={dropdownOptions}
                            onChange={(t, d) => { setSubCategory(d.value) }}
                        />
                    </div>} */}

                    <div className="inline fields">
                        <div className="field three wide">
                            <Checkbox checked={newCategory} label={"Check to add a new sub-category instead"} onClick={(e, data) => {setNewCategory(data.checked)}} />
                        </div>
                    </div>
                    {newCategory ? 
                        <div>
                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>Category Name:</label>
                                </div>
                                <div className="field eight wide">
                                    <input type="text" required name="categoryName" placeholder="Enter Name of the Category" onChange={(e) => setSuperCategory( e.target.value )} />
                                </div>
                            </div>
                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>Sub-Category Name:</label>
                                </div>
                                <div className="field eight wide">
                                    <input type="text" required name="subCategoryName" placeholder="Enter Name of the Sub-Category" onChange={(e) => setSubCategory( e.target.value )} />
                                </div>
                            </div>
                            <div className="inline fields">
                                <div className="field three wide">
                                    <label>Description:</label>
                                </div>
                                <div className="field eight wide">
                                    <input type="text" required name="description" placeholder="Enter Description" onChange={(e) => setDescription( e.target.value )} />
                                </div>
                            </div>
                        </div>
                    :
                        <div className="inline fields">
                            <div className="field three wide">
                                <label>Select sub-category:</label>
                            </div>
                            <Dropdown
                                placeholder='Categories'
                                search
                                selection
                                className="field eight wide"
                                options={dropdownOptions}
                                onChange={(t, d) => { setSubCategory(d.value) }}
                            />
                        </div>
                    }

                    <div className="inline fields">
                        <div className="field three wide">
                            <label>Question:</label>
                        </div>
                        <div className="field eight wide">
                            <input type="text" required name="question" placeholder="Enter Question" onChange={(e) => setQuestion( e.target.value )} />
                        </div>
                    </div>

                    <div className="inline fields" >
                        <div className="field three wide">
                            <label>Choices:</label>
                        </div>
                        <div className="field eight wide " style={{ display: "flex", flexDirection: "column", justifyContent: "space-around" }}>
                            <input type="text" required name="choice" placeholder="Enter Choice" onChange={(e) => setChoice1(e.target.value)} />
                            <input type="text" required name="choice" placeholder="Enter Choice" onChange={(e) => setChoice2(e.target.value)} />
                            <input type="text" name="choice" placeholder="Enter Choice" onChange={(e) => setChoice3(e.target.value)} />
                            <input type="text" name="choice" placeholder="Enter Choice" onChange={(e) => setChoice4(e.target.value)} />
                            <input type="text" name="choice" placeholder="Enter Choice" onChange={(e) => setChoice5(e.target.value)} />
                            <input type="text" name="choice" placeholder="Enter Choice" onChange={(e) => setChoice6(e.target.value)} />
                        </div>
                    </div>

                    <div className="inline fields">
                        <div className="field three wide">
                            <label>Choice Type:</label>
                        </div>
                        <Dropdown
                            placeholder='Choice Type'
                            selection
                            className="choiceTypeDropDown"
                            defaultValue={choiceType}
                            options={[{key: 'text', text: 'Text', value: 'text'}, {key: 'numerical', text: 'Numerical', value: 'numerical'}]}
                            onChange={(t, d) => { setChoiceType(d.value) }}
                        />
                    </div>

                    <div className="poll-buttons" style={{marginTop: "20px"}}>
                        <button className="ui button " type="submit" onClick={() => window.location.reload(false)}>Cancel</button>
                        <button className="ui button " type="submit" onClick={() => savePoll()}>Upload Poll</button>
                    </div>
                    <br />
                </form>
            </div>

            <Modal dimmer={'blurring'} open={bulkUploadPollModal} size="small" onClose={onPollBulkUploadModalClose}>
                <Modal.Content>
                    {/* <a href="/assets/csv/sample-employees.csv" className="icon button right floated" download><i className="icon download" />Download Sample CSV</a>
                    <br /> */}
                    <FileDropZone onFileGiven={handleCsvUpload} />
                    <Button className="center aligned" type="button" onClick={() => setBulkUploadPollModal(false)}>Cancel</Button>
                    <br />
                </Modal.Content>
            </Modal>

            <Modal dimmer={'blurring'} open={showBulkUploadResponseModal} size="mini">
                <Modal.Content><p>{responseModalText}</p></Modal.Content>
                {bulkUploadResponse && bulkUploadResponse.fail.length ?
                    <Modal.Content>
                        <p><div style={{ color: '#FF5A5F' }}>Failed to upload ({bulkUploadResponse.fail.length}) rows:</div>
                            <div>{bulkUploadResponse.fail.map(name => { return <div>{name}</div> })}</div></p>
                    </Modal.Content>
                :null}
                <Modal.Actions className="center aligned"><Button onClick={e => setShowBulkUploadResponseModal(false)}>Ok</Button></Modal.Actions>
            </Modal>
        </div>
    )
}